import { INTAKE_FORM_NAME_MAX_LENGTH } from '@/definitions/intakeForm'

export const NAME_REQUIRED_MESSAGE = 'Give the form a name.'
export const NAME_TOO_LONG_MESSAGE =
  `A name can be at most ${INTAKE_FORM_NAME_MAX_LENGTH} characters.`
